module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Zoom in":"Vergrößern","Zoom out":"Verkleinern","Fit to view":"Alles einpassen"}}')
  delete Component.options._Ctor
}
